import React from 'react';
import IPLAYER from '../../../images/icon/iPLAYER.png';

const IPlayer = ({deviceTypeVersion, text, disabled = false}) => {
    return(
        <span className={"device_icon"}>
            <img src={IPLAYER} style={{opacity: disabled ? 0.7 : 1, webkitFilter: disabled ? 'grayscale(100%)' : undefined}} data-deviceType={'IPLAYER'} data-deviceTypeVersion={deviceTypeVersion}/>
            {text ?  'I Player' : ''}
        </span>
    )
}
export default IPlayer